// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__dEhIg","loader":"styles_loader__iniRG","badge":"styles_badge__flKt_","image":"styles_image__xmnBH","fadeInOut":"styles_fadeInOut__6MepH"};